import React, { useContext, useEffect, useState } from 'react';
import { IProps } from './types';
import * as S from './styles';
import { Context } from "routes/private/Editor/Context";
import { UndoIcon } from '@assets/icons/undoIcon';
import Tooltip from '@components/Tooltip';

const UndoCommandOption : React.FC<IProps> = () => {
  let { onUndoRedo, dataUndo } = useContext(Context);

  return (
    <S.Root>
      <Tooltip tip={"Undo"}>
        <S.ButtonContainer active={dataUndo.length>0} onClick={()=>{if (dataUndo.length>0) onUndoRedo("undo");}}>
          <UndoIcon opacity={dataUndo.length>0 ? 1 : 0.3}/>
        </S.ButtonContainer>
      </Tooltip>
    </S.Root>
  );
}

export default UndoCommandOption;